const SOFT_HYPHEN = "\u00ad";

export const insertSoftHyphens = (text: string, chunkSize = 10, minWordLength = 16) =>
  text
    .split(/(\s+)/)
    .map(token => {
      if (/\s+/.test(token) || token.length < minWordLength) {
        return token;
      }

      return token
        .split("")
        .reduce<string[]>((segments, char, index) => {
          if (index !== 0 && index % chunkSize === 0) {
            segments.push(SOFT_HYPHEN);
          }
          segments.push(char);

          return segments;
        }, [])
        .join("");
    })
    .join("");
